"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var use_action_1 = __importDefault(require("../utils/use-action"));
var useRemoveItem = use_action_1.default;
exports.default = useRemoveItem;
